import { createPagesBrowserClient } from '@supabase/auth-helpers-nextjs'
import { Database } from './types/database'

const supabase = createPagesBrowserClient<Database>()

export default supabase
